import { computed, DestroyRef, Injectable, inject, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarService {
  readonly collapsedWidth = 72;
  readonly maxWidth = 400;
  private readonly narrowScreen = window.matchMedia('(max-width: 767px)');
  readonly isCollapsed = signal(this.narrowScreen.matches);
  private readonly expandedWidth = signal(244);
  readonly width = computed(() => this.isCollapsed() ? this.collapsedWidth : this.expandedWidth());
  readonly isResizing = signal(false);
  private desktopCollapsed = false;

  constructor() {
    const onResize = () => this.isCollapsed.set(this.narrowScreen.matches || this.desktopCollapsed);
    this.narrowScreen.addEventListener('change', onResize);
    inject(DestroyRef).onDestroy(() => this.narrowScreen.removeEventListener('change', onResize));
  }

  toggleSidebar() {
    this.isCollapsed.update(value => !value);
    if (!this.narrowScreen.matches) this.desktopCollapsed = this.isCollapsed();
  }

  resizeTo(width: number) {
    const collapsed = width < 176;
    this.desktopCollapsed = collapsed;
    this.isCollapsed.set(collapsed);
    if (!collapsed) this.expandedWidth.set(Math.min(this.maxWidth, Math.max(192, Math.round(width))));
  }
}
